import ClientLike from "../client-like";

export default class ProjecTaskTypeApi {
  public constructor(private client: ClientLike) {}

  public async all(projectId: number): Promise<ProjectTaskType[]> {
    const data: any[] = await this.client.get("get_project_task_types.php", {
      projectId
    });
    return data.map(
      i => new ProjectTaskType(i.taskTypeId, i.name, i.serviceTemplateTypeId)
    );
  }

  public async getProjectStaffTaskType(projectId: number) {
    return await this.client.get("get_project_staff_task_type.php", {
      projectId: projectId
    });
  }
}

class ProjectTaskType {
  public constructor(
    public id: number,
    public name: string,
    public serviceTemplateTypeId: any
  ) {}
}

export interface ProjectTaskData {
  id?: string;
  name: string;
  users: string[] | number[];
  date: string;
  time?: string;
  project?: string | number;
  canEditProject?: boolean;
  isOwner?: boolean;
  canEditName?: boolean;
}
